import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import { AddOrderingListRequestProductCommand, OrderingListPendingProductRequestViewModel } from 'Api/CoreApi';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import ModalMixin from 'Mixins/ModalMixin';
import ModalEventBus, { IModal } from 'Events/ModalEventBus';
import ComponentEventBus, { IComponentWrapper, Events as ComponentWrapperEvent } from 'Events/ComponentWrapperEventBus';





@Component({
    template: "#ordering-list-request-product-template",
})
export default class OrderingListRequestProductComponent extends mixins(BaseComponent, OrderingListUserMixin, ModalMixin) {
    
    
    @Prop()
    public productKey: string;
    
    public comments: string = '';
    
    async created() {

        if(!this.isAllowed) return;

        this.setLoading();
        await store.dispatch.orderingListRequestProduct.load({});
        this.setLoaded();
    }
    
    get isRequested(): boolean{
        return this.listOfRequestedProducts && this.listOfRequestedProducts.find(x => x.productKey == this.productKey) != null;
    }
    
    get listOfRequestedProducts() : OrderingListPendingProductRequestViewModel[]{
        return store.state.orderingListRequestProduct.list;
    }
    
    
    get canRequestProduct(): boolean{
        //if advanced administrator - dont show the component
        if(this.isAdvancedAdmin) return false;
        
        if(this.list)
        {
            return this.list.permissions.canRequestAddOfItem;   
            // {
            //     return this.list.items.find(x => x.productKey != this.productKey) != null;
            // }
        }
        return false;
    }
    
    get list(){
        return store.state.orderingList.currentOrderingList;
    }
    
    async requestProduct(){
        
        const self = this;
        
        const obj: IModal = <any>{
            header: this.productKey.replace('-at-SHOP1',''),
            message: 'test',
            success: async (payload: any) =>  {
                console.log('comments: ' + payload.comments);
                this.setLoading();
                await store.dispatch.orderingListRequestProduct.request(new AddOrderingListRequestProductCommand({
                    productKey : this.productKey,
                    orderingListId : this.list.id,
                    comments: payload.comments
                }));
                this.setLoaded();
                return;


            },           
            //TODO: what about cancel
            
        };
        
        ComponentEventBus.$emit(ComponentWrapperEvent.ADD, <IComponentWrapper>{type: 'modal-text-component' });
        //it is better safe to wait till the component is initialized and mounted!
        setTimeout(() => {
            ModalEventBus.$emit('show-modal', obj);
        },100)
        
    }
}

Vue.component('ordering-list-request-product', OrderingListRequestProductComponent);